export type TTicketOrder = {
  id: number;
  personId: number;
  date: string;
  status: EOrderStatus;
  description: string;
  tripId: number;
  stationFromId: number;
  stationToId: number;
  tickets: TTicket[];
  ticketQr: string;
  payType: number;
  paySumm: number;
  payReturnUrl: string;
  payConfirmationUrl: string;
  payConfirmationStatus: number;
  payRemoteId: number;
  payCheckDate: string;
};

export type TTicket = {
  id: number;
  orderId: number;
  mainTicketId?: number;
  personId: number;
  date: string;
  refundDate: string;
  status: number;
  description: string;
  tripId: number;
  tariffId: number;
  summ: number;
  stationFrom: TStationName;
  stationTo: TStationName;
  wagonNum?: number;
  seatNum?: number;
  payType: number;
  paySumm: number;
  terminalId: number;
  terminalDocId: number;
  terminalRefundDocId: number;
  terminalQrUid: string;
  cashierId: number;
  departureTime: string;
  departureEstimated: boolean;
  arrivalTime: string;
  arrivalEstimated: boolean;
};

export type TStationName = {
  nameHy: string;
  nameEn: string;
  nameRu: string;
};

/**
 * Статус заказа
 * 0 - новый
 * 1 - обработан успешно
 * 2 - обработан с ошибкой
 * 3 - забронирован
 * 4 - отменен, деньги возвращены
 */
export const enum EOrderStatus {
  created = 0,
  ok = 1,
  error = 2,
  booked = 3,
  canceled = 4,
}
